// File: ProfileCard.js
import React from "react";
import ProfileCardHeader from "./ProfileCardHeader";
import ProfileDescription from "./ProfileDescription";
import ProfileMetrics from "./ProfileMetrics";
import ProfileActions from "./ProfileActions";

const ProfileCard = ({ profile, onDelete }) => {
  return (
    <div className="bg-white border border-gray-100 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 overflow-hidden">
      <ProfileCardHeader profile={profile} />
      <div className="px-3 py-2.5 md:px-4 md:py-3">
        <ProfileDescription description={profile.basic.description} />
        <ProfileMetrics parameters={profile.parameters} />
      </div>
      <ProfileActions profileId={profile._id} onDelete={onDelete} />
    </div>
  );
};

export default ProfileCard;
